import gql from 'graphql-tag';

import { ContentTemplateFragment } from 'lane-shared/graphql/fragments';

export default gql`
  ${ContentTemplateFragment}

  query contentTemplatesOnChannelQuery(
    $channelId: UUID!
    $search: ContentTemplateSearch
    $pagination: PaginationInput
  ) {
    contentTemplatesOnChannel(
      channelId: $channelId
      search: $search
      pagination: $pagination
    ) {
      pageInfo {
        start
        total
        perPage
      }
      items {
        _id
        template {
          ...ContentTemplateFragment
        }
      }
    }
  }
`;
